import { render, staticRenderFns } from "./CreateReceiving.vue?vue&type=template&id=dc640036&"
import script from "./CreateReceiving.vue?vue&type=script&lang=js&"
export * from "./CreateReceiving.vue?vue&type=script&lang=js&"
import style0 from "./CreateReceiving.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports